import { API, Auth } from "aws-amplify";
import { AllClaims } from "src/types";

export const getClaims = async (): Promise<AllClaims> => {
  const user = await Auth.currentAuthenticatedUser();
  const response = await API.get("apiMySpaceGateway", "/claims", {
    headers: { Authorization: user.signInUserSession.idToken.jwtToken },
    response: false,
  });

  return response.data;
};
